<template>
    <div class="sim-tools">
        <div class="bookmarks">
            <a @click="changeBookmark(1)" :class="['bookmark', activeBookmark == 1 ? 'selected' : '']">Sim Query</a>
            <a @click="changeBookmark(2)" :class="['bookmark', activeBookmark == 2 ? 'selected' : '']">IMEI</a>
            <a @click="changeBookmark(3)" :class="['bookmark', activeBookmark == 3 ? 'selected' : '']">PUK</a>
            <a @click="changeBookmark(4)" :class="['bookmark', activeBookmark == 4 ? 'selected' : '']">Devices</a>
            <a @click="changeBookmark(5)" :class="['bookmark', activeBookmark == 5 ? 'selected' : '']">Netcracker</a>
        </div>
        <div class="upload-sims-areas">
            <div class="input-sims-area">
                <p v-if="activeBookmark == 2">Enter IMEI Number ( divide multiple numbers by a coma )</p>
                <p v-else-if="activeBookmark == 4">Enter TAC/IMEI Number ( divide multiple numbers by a coma )</p>
                <p v-else>Scan the barcode of / or enter the SIM number you can find on the back of the SIM card</p>
                <div class="sims-input">
                    <input @keyup="onEnterPress" type="text" class="add-sims-input" v-model="simsInput">
                    <button @click="addSimsFromBtn()" class="add-sims-btn">Apply</button>
                </div>
            </div>
            <div class="dnd-area">
                <div class="image">
                    <img src="../../assets/img/upload-sims.png" alt="">
                </div>
                <div class="text">
                    <h3>Drag and drop list of SIM's or Browse</h3>
                    <h4>The file selected needs to be a CSV, XLS, XLSX or TXT file where the SIMs are seperated by commas.</h4>
                </div>
                <div class="label">
                    <input type="file" id="file-bulk-modal" ref="importFile" v-on:change="readSimFile">
                    <label for="file-bulk-modal" class="btn btn-primary">Browse</label>
                </div>
            </div>
        </div>

        <div v-if="simsFailedValidationFromFile.length > 0" class="invalid-sims-box">
            <div class="invalid-sims-box-header">
                <h3 :class="validationPassedExpanded ? '' : 'no-margin'">SIM Issues</h3>
                <i :class="['fa', validationPassedExpanded ? 'fa-angle-down' : 'fa-angle-left']" @click="validationPassedExpand()"></i>
            </div>
            <div v-for="item of simsFailedValidationFromFile" :class="['sims-group', validationPassedExpanded ? '' : 'sims-hidden']">
                <h6 class="name">{{item.groupName}}</h6>
                <h6 class="desc">{{item.groupDescription}}</h6>
                <div class="list-of-sims">
                    <div v-for="sim of item.iccids" class="sim"> <i class="fts-icon-sim"></i> {{sim}}</div>
                </div>
            </div>
        </div>

        <div class="sims-list-wrapper fts-table-wrapper sim-tools-table">
            <div v-if="activeBookmark != 4 && activeBookmark != 5" class="row">
                <div class="col-md-4 search-filter">
                    <div class="search-box">
                        <input type="text" class="form-control" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                    </div>
                </div>
                <div class="col-md-2 text-right">
                    <label for="size-page">Display:</label>
                    <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                        <option value="40">40</option>
                        <option value="60">60</option>
                        <option value="80">80</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>
            <div class="mb-0 table-outline table-responsive-sm table-sims fts-table">
                <table v-if='simsList.length > 0 || simsFailedValidationFromFile.length > 0' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-sim-tools">
                    <thead role="rowgroup">
                        <tr v-if="activeBookmark == 1" role="row">
                            <th @click="changeSort(2)" :aria-sort="setAreaSort(2)">Company Name</th>
                            <th>ICCID</th>
                            <th>MSISDN</th>
                            <th @click="changeSort(5)" :aria-sort="setAreaSort(5)">Status</th>
                            <th @click="changeSort(6)" :aria-sort="setAreaSort(6)">Carrier</th>
                        </tr>
                        <tr v-else-if="activeBookmark == 2">
                            <th @click="changeSort(1)" :aria-sort="setAreaSort(1)">IMEI</th>
                            <th @click="changeSort(3)" :aria-sort="setAreaSort(3)">SIM</th>
                            <th @click="changeSort(4)" :aria-sort="setAreaSort(4)">MSISDN</th>
                            <th @click="changeSort(2)" :aria-sort="setAreaSort(2)">Company Name</th>
                            <th @click="changeSort(5)" :aria-sort="setAreaSort(5)">Last Update</th>
                        </tr>
                        <tr v-else-if="activeBookmark == 3">
                            <th @click="changeSort(1)" :aria-sort="setAreaSort(1)">ICCID</th>
                            <th>PUK1</th>
                            <th>PUK2</th>
                            <th>Activation Elligible</th>
                            <th>wfcElligble</th>
                        </tr>
                        <tr v-else-if="activeBookmark == 4">
                            <th>TAC/IMEI</th>
                            <th>Status</th>
                            <th>Response</th>
                        </tr>
                        <tr v-else-if="activeBookmark == 5">
                            <th>ICCID</th>
                            <th>Status</th>
                            <th>Response</th>
                        </tr>
                    </thead>

                    <tbody v-if="activeBookmark == 1">
                        <tr v-for="(item, index) in simsList" v-bind:key="index">
                            <td>{{item.companyName}}</td>
                            <td>{{item.iccid}}</td>
                            <td>{{item.msisdn}}</td>
                            <td>{{item.status}}</td>
                            <td v-if="item.carrierId == 1">Simon IoT</td>
                            <td v-else-if="item.carrierId == 2">T-mobile</td>
                            <td v-else-if="item.carrierId == 3">Vodafone</td>
                            <td v-else>--</td>
                        </tr>
                    </tbody>
                    <tbody v-if="activeBookmark == 2">
                        <tr v-for="(item, index) in simsList" v-bind:key="index">
                            <td>{{item.imei}}</td>
                            <td>{{item.iccid}}</td>
                            <td>{{item.msisdn}}</td>
                            <td>{{item.companyName}}</td>
                            <td>{{item.updatedAt}}</td>
                        </tr>
                    </tbody>
                    <tbody v-if="activeBookmark == 3">
                        <tr v-for="(item, index) in simsList" v-bind:key="index">
                            <td>{{item.iccid}}</td>
                            <td>{{item.puk1}}</td>
                            <td>{{item.puk2}}</td>
                            <td>{{item.activationEligible}}</td>
                            <td>{{item.wfcEligible}}</td>
                        </tr>
                    </tbody>
                    <tbody v-if="activeBookmark == 4">
                        <tr v-for="(item, index) in simsList" v-bind:key="index">
                            <td>{{item.deviceId}}</td>
                            <td>{{item.status}}</td>
                            <td v-if="item.response"><a @click="showJSON(item.response)">JSON file</a></td>
                            <td v-else>No response</td>
                        </tr>
                    </tbody>
                    <tbody v-if="activeBookmark == 5">
                        <tr v-for="(item, index) in simsList" v-bind:key="index">
                            <td>{{item.iccid}}</td>
                            <td>{{item.status}}</td>
                            <td v-if="item.response"><a @click="showJSON(item.response)">JSON file</a></td>
                            <td v-else>No response</td>
                        </tr>
                    </tbody>
                    <div class="no-sims" v-if="loading == false && noSims == true">
                        <h2 class="text">You uploaded no valid SIMs</h2>
                    </div>

                    <div class="no-sims-uploaded" v-if="simsList.length == 0 && simsFailedValidationFromFile.length == 0 && loading == false">
                        <h2 class="text">SIM cards will appear here after uploading list.</h2>
                    </div>
                </table>
            </div>
            <div class="loader-sim-list" v-if="loading && noSims == false">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
            </div>
            <nav class="nav-sim-query">
                <button v-if="loading == false && (simsList.length > 0 || simsFailedValidationFromFile.length > 0)" class="btn btn-primary" @click="resetSimsLists()">Reset</button>
                <Paginate v-if="paginationCount" :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" name="simSwapPaginate"></Paginate>
                <button v-if="loading == false && (simsList.length > 0 || simsFailedValidationFromFile.length > 0) && (activeBookmark != 4 && activeBookmark != 5)" class="btn btn-primary" @click="showExportSelect()">Export</button>
            </nav>
            <div class="buttons-table">
            </div>
        </div>

        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelect()">Cancel</button>
            </div>
        </b-modal>

        <b-modal size="lg" ref="jsonModal" id="jsonModal" centered hide-header hide-footer>
            <h3>JSON file</h3>
            <i @click="closeJSON()" class="fa fa-close"></i>
            <pre>{{jsonModalContent}}</pre>
            <div class="close-bar">
                <button @click="downloadJSON()" class="btn btn-primary">Download JSON</button>
                <button @click="closeJSON()" class="btn btn-light">Close</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Axios from "axios";
    import globalStore from "../../variables";
    import Paginate from 'vuejs-paginate'

    export default {
        name: "QueryTools",
        components: {
            Paginate: Paginate
        },
        data() {
            return {
                activeBookmark: 1,
                simsInput: '',
                simsInputParsed: [],
                simsFailedValidationFromFile: [],
                simsList: [],
                sortSettings: {
                    page: 1,
                    size: 40,
                    sort: 1,
                    desc: false
                },
                paginationCount: null,
                loading: false,
                noSims: false,
                filter: '',
                searchString: '',
                validationPassedExpanded: true,
                transactionIdPUK: null,
                jsonModalContent: ''
            }
        },
        methods: {
            changeBookmark(id) {
                if (id != this.activeBookmark) {
                    this.resetSimsLists();
                    this.activeBookmark = id
                }
            },
            onEnterPress(ev) {
                ev.keyCode === 13 ? this.addSimsFromBtn() : null;
            },
            addSimsFromBtn() {
                if (this.simsInput.length == 0) {
                    if (this.activeBookmark != 2) {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Incorrect input value',
                            text: 'You put no ICCIDs into input. Please, fill it with value.',
                            duration: 3000,
                        });
                    } else if (this.activeBookmark == 2) {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Incorrect input value',
                            text: 'You put no IMEIs into input. Please, fill it with value.',
                            duration: 3000,
                        });
                    } else if (this.activeBookmark == 4) {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Incorrect input value',
                            text: 'You put no Device Indenty Number into input. Please, fill it with value.',
                            duration: 3000,
                        });
                    }
                    return false
                }
                if (this.activeBookmark != 4) {
                    this.filter = ''
                    this.searchString = ''
                    this.simsInputParsed = []
                    let simsArray = this.simsInput
                    if (simsArray.indexOf(',') > -1) {
                        simsArray = this.simsInput.split(',')
                    }

                    if (typeof simsArray == 'object') {
                        for (let item of simsArray) {
                            if (item.indexOf(' ') > -1) {
                                let arrItem = item.split(' ')
                                for (let sim of arrItem) {
                                    sim = sim.replace(/f/g, '');
                                    sim = sim.replace(/F/g, '');
                                    if (sim != "") {
                                        this.simsInputParsed.push(sim)
                                    }
                                }
                            } else {
                                item = item.replace(/f/g, '');
                                item = item.replace(/F/g, '');
                                this.simsInputParsed.push(item)
                            }
                        }
                    } else {
                        if (simsArray.indexOf(' ') > -1) {
                            this.simsInputParsed = this.simsInput.split(' ')
                        } else {
                            this.simsInputParsed = [this.simsInput]
                        }
                    }
                    let removedSpacesArray = []
                    for (let iccid of this.simsInputParsed) {
                        if (iccid.length > 0) {
                            removedSpacesArray.push(iccid)
                        }
                    }
                    this.simsInputParsed = removedSpacesArray

                    if (this.simsInputParsed.length == 0) {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Incorrect input value',
                            text: 'You put no ICCIDs into input. Please, fill it with value.',
                            duration: 3000,
                        });
                        return false
                    }

                    this.simsInput = ''
                } else {
                    this.filter = ''
                    this.searchString = ''
                    this.simsInputParsed = []
                    let simsArray = this.simsInput
                    if (simsArray.indexOf(',') > -1) {
                        simsArray = this.simsInput.split(',')
                    }

                    if (typeof simsArray == 'object') {
                        for (let item of simsArray) {
                            if (item.indexOf(' ') > -1) {
                                let arrItem = item.split(' ')
                                for (let sim of arrItem) {
                                    if (sim != "") {
                                        this.simsInputParsed.push(sim)
                                    }
                                }
                            } else {
                                this.simsInputParsed.push(item)
                            }
                        }
                    } else {
                        if (simsArray.indexOf(' ') > -1) {
                            this.simsInputParsed = this.simsInput.split(' ')
                        } else {
                            this.simsInputParsed = [this.simsInput]
                        }
                    }
                    let removedSpacesArray = []
                    for (let iccid of this.simsInputParsed) {
                        if (iccid.length > 0) {
                            removedSpacesArray.push(iccid)
                        }
                    }
                    this.simsInputParsed = removedSpacesArray

                    if (this.simsInputParsed.length == 0) {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Incorrect input value',
                            text: 'You put no ICCIDs into input. Please, fill it with value.',
                            duration: 3000,
                        });
                        return false
                    }

                    this.simsInput = ''
                }
                if (this.activeBookmark == 1) {
                    this.getSimQuery(true)
                } else if (this.activeBookmark == 2) {
                    this.getSimsIMEI(true)
                } else if (this.activeBookmark == 3) {
                    this.getSimsPUK(true, true)
                } else if (this.activeBookmark == 4) {
                    this.getDevices()
                } else if (this.activeBookmark == 5) {
                    this.getNetcrackers()
                }
            },
            readSimFile(ev) {
                this.filter = ''
                this.searchString = ''
                if (ev.target) {
                    var f = ev.target.files[0];
                } else {
                    var f = ev[0];
                }

                var ext = f.name.slice(f.name.lastIndexOf("."));

                if (ext === ".csv") {

                    var ret = [];
                    var r = new FileReader();
                    r.onload = (e) => {
                        var ct = r.result;
                        var words;

                        ct.indexOf("\n") > -1 ? words = ct.split("\n") : null;

                        if (typeof(words) == 'object') {
                            let tempArr = [];

                            for (let i = 0; i < words.length; i++) {
                                if (words[i].indexOf(",") > -1) {
                                    let temptempArr = words[i].split(",");
                                    for (let item in temptempArr) {
                                        if (temptempArr[item].length > 0) {
                                            tempArr.push(temptempArr[item])
                                        }
                                    }
                                } else {
                                    tempArr.push(words[i]);
                                }
                            }

                            words = tempArr
                        } else {
                            (ct.indexOf(",") > -1) ? words = ct.split(",") : null;
                        }

                        var len = words.length;
                        for (let i = 0 ; i < len ; i++){
                            words[i] = words[i].replace(/\D/g,'');
                            words[i] != "" ? ret.push(words[i]) : null;
                        }
                        this.simsInputParsed = ret
                        if (this.activeBookmark == 1) {
                            this.getSimQuery(true)
                        } else if (this.activeBookmark == 2) {
                            this.getSimsIMEI(true)
                        } else if (this.activeBookmark == 3) {
                            this.getSimsPUK(true, true)
                        } else if (this.activeBookmark == 4) {
                            this.getDevices()
                        } else if (this.activeBookmark == 5) {
                            this.getNetcrackers()
                        }
                    }
                    r.readAsText(f);
                    this.$refs.importFile.value = null
                } else if (ext === ".xlsx" || ext === ".xls") {
                    let formData = new FormData();
                    formData.append('file', f);
                    if (this.activeBookmark == 2) {
                        Axios.post(`${globalStore.data.restApiUrl}/imei-query/parse/xlsx`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                            .then(response => {
                                this.simsInputParsed = response.data
                                this.getSimsIMEI(true)
                            })
                            .catch(error => {
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Reading file error',
                                    text: 'An error has occured during reading file.',
                                    duration: 3000,
                                });
                                console.log(error)
                            })
                    } else if (this.activeBookmark == 4) {
                        Axios.post(`${globalStore.data.restApiUrl}/device/parse/xlsx`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                            .then(response => {
                                this.simsInputParsed = response.data
                                this.getDevices()
                            })
                            .catch(error => {
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Reading file error',
                                    text: 'An error has occured during reading file.',
                                    duration: 3000,
                                });
                                console.log(error)
                            })
                    } else {
                        Axios.post(`${globalStore.data.restApiUrl}/sims/parse/xlsx`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                            .then(response => {
                                this.simsInputParsed = response.data
                                if (this.activeBookmark == 1) {
                                    this.getSimQuery(true)
                                } else if (this.activeBookmark == 3) {
                                    this.getSimsPUK(true, true)
                                }
                            })
                            .catch(error => {
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Reading file error',
                                    text: 'An error has occured during reading file.',
                                    duration: 3000,
                                });
                                console.log(error)
                            })
                    }
                    this.$refs.importFile.value = null
                } else {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Incorrect file format',
                        text: 'File must be in .csv, .xls or .xlsx format.',
                        duration: 3000,
                    });
                }
            },
            readDraggedList(simList) {
                var words;
                var ret = [];

                simList.indexOf("\n") > -1 ? words = simList.split("\n") : null;
                if (typeof(words) == 'object') {
                    let tempArr = [];

                    for (let i = 0; i < words.length; i++) {
                        if (words[i].indexOf(",") > -1) {
                            let temptempArr = words[i].split(",");
                            for (let item in temptempArr) {
                                if (temptempArr[item].length > 0) {
                                    tempArr.push(temptempArr[item])
                                }
                            }
                        } else {
                            tempArr.push(words[i]);
                        }
                    }

                    words = tempArr
                } else {
                    simList.indexOf(",") > -1 ? words = simList.split(",") : null;
                    if (words == undefined) {
                        simList.indexOf(" ") > -1 ? words = simList.split(" ") : null;
                    }
                    if (words == undefined) {
                        words = [simList]
                    }
                }

                var len = words.length;

                for (let i = 0 ; i < len ; i++){
                    words[i] = words[i].replace(/\D/g,'');
                    words[i] != ""  ? ret.push(words[i]) : null;
                }
                this.simsInputParsed = ret
                if (this.activeBookmark == 1) {
                    this.getSimQuery(true)
                } else if (this.activeBookmark == 2) {
                    this.getSimsIMEI(true)
                } else if (this.activeBookmark == 3) {
                    this.getSimsPUK(true, true)
                }
            },
            getPagination() {
                let parsedData = {
                    iccids: this.simsInputParsed
                }
                Axios.post(globalStore.data.restApiUrl + '/sims/query/page-count?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString, parsedData)
                    .then(response => {
                        this.paginationCount = response.data
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Pagination error',
                            text: 'An error has occured during getting pagination info, please contact support.',
                            duration: 3000,
                        });
                        console.log(error);
                    })
            },
            getSimQuery(resetPage) {
                this.loading = true
                if (resetPage) {
                    this.sortSettings.page = 1
                    this.getPagination()
                }
                let parsedData = {
                    iccids: this.simsInputParsed
                }

                if (this.simsInputParsed.length == 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'No correct SIMs',
                        text: 'You uploaded list with no correct SIM number. Please check your list.',
                        duration: 5000,
                    });
                    this.loading = false
                    return false
                }

                Axios.post(globalStore.data.restApiUrl + '/sims/query?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString,  parsedData)
                    .then(response => {
                        this.simsList = response.data.validQueryItems
                        this.simsFailedValidationFromFile = response.data.invalidValidationGroups

                        if (this.simsList.length > 0) {
                            this.noSims = false
                        } else {
                            this.noSims = true
                        }
                        this.loading = false
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'SIM Query Error',
                            text: 'An error has occured during getting SIM Query info, please contact support.',
                            duration: 3000,
                        });
                        this.noSims = true
                        this.loading = false
                        console.log(error);
                    })
            },
            getSimsIMEI(resetPage) {
                this.loading = true
                if (resetPage) {
                    this.sortSettings.page = 1
                }

                let parsedData = this.simsInputParsed

                if (this.simsInputParsed.length == 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'No correct SIMs',
                        text: 'You uploaded list with no correct SIM number. Please check your list.',
                        duration: 5000,
                    });
                    this.loading = false
                    return false
                }

                let blockErrorDisplay = false

                Axios.post(globalStore.data.restApiUrl + '/imei-query/page-count?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString, parsedData)
                    .then(response => {
                        this.paginationCount = response.data
                    })
                    .catch(error => {
                        this.noSims = true
                        this.loading = false
                        if (error.response && error.response.data && error.response.data.errors && blockErrorDisplay == false) {
                            let errorSims = []
                            for (let err of error.response.data.errors) {
                                errorSims.push(err.details)
                            }
                            errorSims = errorSims.join(", ");

                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Invaid IMEI numbers',
                                text: 'Following IMEI numbers are incorrect. Please upload correct ones. <br/>' + errorSims,
                                duration: 8000,
                            });

                        } else if (blockErrorDisplay == false) {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'IMEI Query Error',
                                text: 'An error has occured during getting IMEI Query info, please contact support.',
                                duration: 3000,
                            });
                        }
                        blockErrorDisplay = true
                        console.log(error);
                    })
                Axios.post(globalStore.data.restApiUrl + '/imei-query?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString,  parsedData)
                    .then(response => {
                        if (response.data.invalidValidationGroups == undefined) {
                            this.simsList = response.data
                        } else {
                            this.simsFailedValidationFromFile = response.data.invalidValidationGroups
                        }

                        if (this.simsList.length > 0) {
                            this.noSims = false
                        } else {
                            this.noSims = true
                        }
                        this.loading = false
                    })
                    .catch(error => {
                        this.noSims = true
                        this.loading = false
                        if (error.response && error.response.data && error.response.data.errors && blockErrorDisplay == false) {
                            let errorSims = []
                            for (let err of error.response.data.errors) {
                                errorSims.push(err.details)
                            }
                            errorSims = errorSims.join(", ");

                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Invaid IMEI numbers',
                                text: 'Following IMEI numbers are incorrect. Please upload correct ones. <br/>' + errorSims,
                                duration: 8000,
                            });

                        } else if (blockErrorDisplay == false) {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'IMEI Query Error',
                                text: 'An error has occured during getting IMEI Query info, please contact support.',
                                duration: 3000,
                            });
                        }
                        blockErrorDisplay = true
                        console.log(error);
                    })
            },
            getSimsPUK(isFirst, resetPage) {
                this.loading = true
                this.paginationCount = 0

                if (resetPage) {
                    this.sortSettings.page = 1
                }

                let parsedData = this.simsInputParsed

                if (this.simsInputParsed.length == 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'No correct SIMs',
                        text: 'You uploaded list with no correct SIM number. Please check your list.',
                        duration: 5000,
                    });
                    this.loading = false
                    return false
                }

                if (isFirst) {
                    Axios.post(globalStore.data.restApiUrl + '/puk-query?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString + this.searchString, parsedData)
                        .then(response => {
                            if (response.data.invalidValidationGroups == undefined) {
                                this.simsList = response.data.dtoList
                                this.transactionIdPUK = response.data.transactionId
                            } else {
                                this.simsFailedValidationFromFile = response.data.invalidValidationGroups
                            }

                            if (this.simsList.length > 0) {
                                this.noSims = false
                            } else {
                                this.noSims = true
                            }

                            Axios.post(globalStore.data.restApiUrl + '/puk-query/page-count?size=' + this.sortSettings.size + '&transactionId=' + this.transactionIdPUK + this.searchString)
                                .then(response => {
                                    this.paginationCount = response.data
                                    this.loading = false
                                })
                                .catch(error => {
                                    this.noSims = true
                                    this.loading = false
                                    this.$notify({
                                        type: 'warn',
                                        group: 'notification',
                                        title: 'PUK Query Error',
                                        text: 'An error has occured during getting PUK Query info, please contact support.',
                                        duration: 3000,
                                    });

                                    console.log(error);
                                })
                        })
                        .catch(error => {
                            this.noSims = true
                            this.loading = false

                            if (error.response && error.response.data && error.response.data.errors) {
                                let errorSims = []
                                for (let err of error.response.data.errors) {
                                    errorSims.push(err.details)
                                }
                                errorSims = errorSims.join(", ");

                                this.$notify({
                                    type: 'warn',
                                    group: 'notification',
                                    title: 'Invaid ICCIDs numbers',
                                    text: 'Following ICCIDs numbers are incorrect. Please upload correct ones. <br/>' + errorSims,
                                    duration: 8000,
                                });

                            } else {
                                this.$notify({
                                    type: 'warn',
                                    group: 'notification',
                                    title: 'PUK Query Error',
                                    text: 'An error has occured during getting PUK Query info, please contact support.',
                                    duration: 3000,
                                });
                            }
                        })
                } else {
                    Axios.post(globalStore.data.restApiUrl + '/puk-query/existing?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + '&transactionId=' + this.transactionIdPUK + this.searchString)
                        .then(response => {
                            if (response.data.invalidValidationGroups == undefined) {
                                this.simsList = response.data
                            } else {
                                this.simsFailedValidationFromFile = response.data.invalidValidationGroups
                            }

                            if (this.simsList.length > 0) {
                                this.noSims = false
                            } else {
                                this.noSims = true
                            }

                            Axios.post(globalStore.data.restApiUrl + '/puk-query/page-count?size=' + this.sortSettings.size + '&transactionId=' + this.transactionIdPUK + this.searchString)
                                .then(response => {
                                    this.paginationCount = response.data
                                    this.loading = false
                                })
                                .catch(error => {
                                    this.noSims = true
                                    this.loading = false
                                    this.$notify({
                                        type: 'warn',
                                        group: 'notification',
                                        title: 'PUK Query Error',
                                        text: 'An error has occured during getting PUK Query info, please contact support.',
                                        duration: 3000,
                                    });

                                    console.log(error);
                                })
                        })
                        .catch(error => {
                            this.noSims = true
                            this.loading = false

                            if (error.response && error.response.data && error.response.data.errors) {
                                let errorSims = []
                                for (let err of error.response.data.errors) {
                                    errorSims.push(err.details)
                                }
                                errorSims = errorSims.join(", ");

                                this.$notify({
                                    type: 'warn',
                                    group: 'notification',
                                    title: 'Invaid ICCIDs numbers',
                                    text: 'Following ICCIDs numbers are incorrect. Please upload correct ones. <br/>' + errorSims,
                                    duration: 8000,
                                });

                            } else {
                                this.$notify({
                                    type: 'warn',
                                    group: 'notification',
                                    title: 'PUK Query Error',
                                    text: 'An error has occured during getting PUK Query info, please contact support.',
                                    duration: 3000,
                                });
                                console.log(error)
                            }
                        })
                }
            },
            getDevices() {
                this.loading = true
                let parsedData = {deviceIdentityNumber: this.simsInputParsed}
                Axios.post(globalStore.data.restApiUrl + '/device/query', parsedData)
                    .then(response => {
                        this.simsList = response.data
                        this.loading = false
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            for (let err of error.response.data.errors) {
                                if (err.errorCode == 'VALIDATION_EXCEPTION') {
                                    let details = err.details
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: err.errorMessage,
                                        text: 'Passed ' + details.substr(details.indexOf('value: '), details.lenght).replace('.', '').replace('[', '').replace(']', '') + ' is incorrect',
                                        duration: 5000,
                                    });
                                } else {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: err.errorMessage,
                                        text: err.details,
                                        duration: 5000,
                                    });
                                }
                            }
                        } else {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Devices request error',
                                text: 'Something went wrong during getting devices info. Please contact support',
                                duration: 5000,
                            });
                        }
                        this.loading = false
                        console.log(error)
                    })
            },
            getNetcrackers() {
                this.loading = true

                let parsedData = this.simsInputParsed
                Axios.post(globalStore.data.restApiUrl + '/network-query?allResults=true', parsedData)
                    .then(response => {
                        this.simsList = response.data.queryDtos
                        this.loading = false
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            for (let err of error.response.data.errors) {
                                if (err.errorCode == 'VALIDATION_EXCEPTION') {
                                    let details = err.details
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: err.errorMessage,
                                        text: 'Passed ' + details.substr(details.indexOf('value: '), details.lenght).replace('.', '').replace('[', '').replace(']', '') + ' is incorrect',
                                        duration: 5000,
                                    });
                                } else {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: err.errorMessage,
                                        text: err.details,
                                        duration: 5000,
                                    });
                                }
                            }
                        } else {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Devices request error',
                                text: 'Something went wrong during getting devices info. Please contact support',
                                duration: 5000,
                            });
                        }
                        this.loading = false
                        console.log(error)
                    })
            },
            showJSON(json) {
                this.jsonModalContent = json
                this.$refs['jsonModal'].show();
            },
            downloadJSON() {
                var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.jsonModalContent));
                var dlAnchorElem = document.createElement('a');
                dlAnchorElem.setAttribute("href",     dataStr     );
                dlAnchorElem.setAttribute("download", "JSON File.json");
                dlAnchorElem.click();
            },
            closeJSON() {
                this.$refs['jsonModal'].hide();
                setTimeout(() => {
                    this.jsonModalContent = ''
                }, 500)
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            searchRow: function () {
                this.loading = true;
                if (this.filter.length > 0) {
                    this.searchString = '&search=' + this.filter;
                } else {
                    this.searchString = '';
                }
                if (this.activeBookmark == 1) {
                    this.getSimQuery(true)
                } else if (this.activeBookmark == 2) {
                    this.getSimsIMEI(true)
                } else if (this.activeBookmark == 3) {
                    this.getSimsPUK(false, true)
                }
            },
            sizePage: function () {
                this.loading = true;
                if (this.activeBookmark == 1) {
                    this.getSimQuery(true)
                } else if (this.activeBookmark == 2) {
                    this.getSimsIMEI(true)
                } else if (this.activeBookmark == 3) {
                    this.getSimsPUK(false, true)
                }
            },
            paginationControll(ev) {
                this.loading = true;
                this.sortSettings.page = ev;
                if (this.activeBookmark == 1) {
                    this.getSimQuery(false)
                } else if (this.activeBookmark == 2) {
                    this.getSimsIMEI(false)
                } else if (this.activeBookmark == 3) {
                    this.getSimsPUK(false, false)
                }
            },
            resetSimsLists() {
                this.simsList = []
                this.simsFailedValidationFromFile = []
                this.loading = false
                this.noSims = false
                this.paginationCount = 0
                this.filter = ''
            },
            showExportSelect() {
                this.$refs['fileFormatModal'].show()
            },
            hideExportSelect() {
                this.$refs['fileFormatModal'].hide()
            },
            exportCsv() {
                if (this.activeBookmark == 1) {
                    let parsedData = {
                        iccids: this.simsInputParsed
                    }
                    Axios.post(globalStore.data.restApiUrl + '/sims/query/csv?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString, parsedData)
                        .then(response => {
                            let csvContent = "data:text/csv;charset=utf-8," + response.data;
                            var fileLink = document.createElement('a');
                            fileLink.href = csvContent;
                            fileLink.setAttribute('download', 'SIM Query.csv');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            this.hideExportSelect();
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'SIMs export went wrong',
                            text: 'Error Exporting SIM Query - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                } else if (this.activeBookmark == 2) {
                    let parsedData = this.simsInputParsed

                    Axios.post(globalStore.data.restApiUrl + '/imei-query/csv?sort=' + this.sortSettings.sort, parsedData)
                        .then(response => {
                            let csvContent = "data:text/csv;charset=utf-8," + response.data;
                            var fileLink = document.createElement('a');
                            fileLink.href = csvContent;
                            fileLink.setAttribute('download', 'IMEI Query.csv');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            this.hideExportSelect();
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'IMEI export went wrong',
                            text: 'Error Exporting IMEI Query - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                } else if (this.activeBookmark == 3) {
                    let parsedData = this.simsInputParsed

                    Axios.post(globalStore.data.restApiUrl + '/puk-query/csv?sort=' + this.sortSettings.sort + '&transactionId=' + this.transactionIdPUK, parsedData)
                        .then(response => {
                            let csvContent = "data:text/csv;charset=utf-8," + response.data;
                            var fileLink = document.createElement('a');
                            fileLink.href = csvContent;
                            fileLink.setAttribute('download', 'PUK Query.csv');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            this.hideExportSelect();
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'PUK export went wrong',
                            text: 'Error Exporting PUK Query - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                }
            },
            exportXlsx() {
                if (this.activeBookmark == 1) {
                    let parsedData = {
                        iccids: this.simsInputParsed
                    }
                    Axios.post(globalStore.data.restApiUrl + '/sims/query/xlsx?size=' + this.sortSettings.size + '&page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString, parsedData, {responseType: 'blob'})
                        .then((response) => {
                            const fileLink = URL.createObjectURL(new Blob([response.data],
                                {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                                )
                            );
                            const link = document.createElement('a')
                            link.href = fileLink
                            link.setAttribute('download', 'SIM Query.xlsx')
                            document.body.appendChild(link)
                            link.click()
                            this.hideExportSelect();
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'SIMs export went wrong',
                            text: 'Error Exporting SIM Query - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                } else if (this.activeBookmark == 2) {
                    let parsedData = this.simsInputParsed

                    Axios.post(globalStore.data.restApiUrl + '/imei-query/xlsx?sort=' + this.sortSettings.sort, parsedData, {responseType: 'blob'})
                        .then((response) => {
                            const fileLink = URL.createObjectURL(new Blob([response.data],
                                {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                                )
                            );
                            const link = document.createElement('a')
                            link.href = fileLink
                            link.setAttribute('download', 'IMEI Query.xlsx')
                            document.body.appendChild(link)
                            link.click()
                            this.hideExportSelect();
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'IMEI export went wrong',
                            text: 'Error Exporting IMEI Query - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                } else if (this.activeBookmark == 3) {
                    let parsedData = this.simsInputParsed
                    Axios.post(globalStore.data.restApiUrl + '/puk-query/xlsx?sort=' + this.sortSettings.sort + '&transactionId=' + this.transactionIdPUK, parsedData, {responseType: 'blob'})
                        .then((response) => {
                            const fileLink = URL.createObjectURL(new Blob([response.data],
                                {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                                )
                            );
                            const link = document.createElement('a')
                            link.href = fileLink
                            link.setAttribute('download', 'PUK Query.xlsx')
                            document.body.appendChild(link)
                            link.click()
                            this.hideExportSelect();
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'PUK export went wrong',
                            text: 'Error Exporting PUK Query - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                }
            },
            validationPassedExpand() {
                this.validationPassedExpanded = !this.validationPassedExpanded
            },
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                if (this.activeBookmark == 1) {
                    this.getSimQuery(false)
                } else if (this.activeBookmark == 2) {
                    this.getSimsIMEI(false)
                } else if (this.activeBookmark == 3) {
                    this.getSimsPUK(false, false)
                }
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            }
        },
        mounted() {
            var self = this;
            document.addEventListener("dragenter", function (e) {
                e.preventDefault();

                if (document.querySelector(".dnd-area") && !document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                    document.querySelector(".dnd-area").classList.add('dragged-fiel');
                }

                e.dataTransfer.setData("text/plain", e.target.id);
                e.dataTransfer.setData("text", e.target.id);
            });

            document.addEventListener("dragleave", function (e) {
                e.preventDefault();

                if (document.querySelector(".dnd-area") && !document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                    document.querySelector(".dnd-area").classList.add('dragged-fiel');
                }
            });

            document.addEventListener("dragover", function (e) {
                e.preventDefault();
            });

            let dndArea = document.querySelector(".dnd-area");

            dndArea.addEventListener("drop", function (e) {
                e.preventDefault();

                if (document.querySelector(".dnd-area") && document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                    document.querySelector(".dnd-area").classList.remove('dragged-fiel');
                }

                var files = e.dataTransfer.files;

                //this.uploadFile(files);
                if (files && files.length > 0) {
                    self.readSimFile(files);
                } else if (e.dataTransfer.getData("text").length > 0) {
                    self.readDraggedList(e.dataTransfer.getData("text"))
                } else {
                    self.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Wrong item dropped',
                        text: 'Item you dropped has not been recognized as a file or a list.',
                        duration: 5000,
                    })
                }
            });

            document.addEventListener("drop", function (e) {
                e.preventDefault();

                if (document.querySelector(".dnd-area") && document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                    document.querySelector(".dnd-area").classList.remove('dragged-fiel');
                }
            });
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
    .sim-tools {
        margin-bottom: 20px;
        border: 1px solid #c8ced3;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background-color: #fff;

        .bookmarks {
            display: flex;
            border-bottom: 1px solid #dbdfe2;
            margin-bottom: 20px;
            .bookmark {
                width: 180px;
                padding: 20px 0;
                text-transform: uppercase;
                text-align: center;
                font-weight: 700;
                cursor: pointer;
                &.selected {
                    color: #0088ff;
                    border: 1px solid #dbdfe2;
                    border-bottom: 1px solid #ffffff;
                    margin-bottom: -1px;
                    -webkit-border-radius: 6px 6px 0 0;
                    -moz-border-radius: 6px 6px 0 0;
                    border-radius: 6px 6px 0 0;
                }
            }
        }

        .sim-query-desc {
            padding: 0 20px;
            margin: 0 0 24px 0;
            font-size: 14px;
        }

        .upload-sims-areas {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            margin-bottom: 20px;
            padding: 0 20px;
            .input-sims-area {
                width: calc(50% - 10px);
                margin-right: 20px;
                padding: 20px;
                border: 1px solid #C9CFD4;
                border-radius: 5px;
                .sims-input {
                    display: flex;

                    .add-sims-input {
                        flex-grow: 1;
                        border-top-left-radius: 5px;
                        border-bottom-left-radius: 5px;
                        border: 1px solid #C9CFD4;
                        border-right: 0;
                        &:focus {
                            outline: none;
                        }
                    }
                    .add-sims-btn {
                        padding: 7px 20px;
                        background-color: #55cd6c;
                        border-top-right-radius: 5px;
                        border-bottom-right-radius: 5px;
                        border: 1px solid #C9CFD4;
                        border-left: 0;
                        color: #fff;
                        font-weight: 700;
                    }
                }
            }

            .dnd-area {
                display: flex;
                justify-content: center;
                align-content: center;
                align-items: center;
                width: calc(50% - 10px);
                padding: 20px;

                border: 2px dotted #2F353A;
                border-radius: 5px;

                &.dragged-fiel {
                    background-color: #b2dbff;
                    .spacer-wrap .spacer span {
                        background-color: #b2dbff;
                    }
                }

                .image {
                    margin-right: 20px;

                    img {
                        max-width: 60px;
                    }
                }

                .text {
                    margin-right: 25px;

                    h3 {
                        margin: 0;
                        font-size: 12px;
                        line-height: 24px;
                        color: #2F353A;
                    }

                    h4 {
                        margin: 0;
                        font-size: 12px;
                        line-height: 16px;
                        color: #979A9C;
                    }
                }

                .label {
                    input {
                        display: none;
                    }

                    label {
                        margin: 0;
                    }
                }
            }
        }

        .invalid-sims-box {
            padding: 20px;
            margin: 0 20px 20px;
            background-color: #ffe3e3;
            border: 1px solid #FC4D4D;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            .invalid-sims-box-header {
                display: flex;
                justify-content: space-between;
                h3 {
                    margin: 0 0 20px 0;
                    font-size: 15px;
                    font-weight: 700;
                    &.no-margin {
                        margin: 0;
                    }
                }
                i {
                    font-size: 20px;
                    color: #0088ff;
                    cursor: pointer;
                }
            }
            .sims-group {
                margin-bottom: 10px;
                &.sims-hidden{
                    display: none;
                }
                .name {
                    margin: 0 0 4px;
                    font-size: 15px;
                    font-weight: 700;
                }
                .desc {
                    margin: 0 0 15px;
                    font-size: 12px;
                    color: #515B65;
                    font-weight: 400;
                }
                .list-of-sims {
                    display: flex;
                    flex-wrap: wrap;
                    .sim {
                        display: flex;
                        align-items: center;
                        margin: 0 50px 12px 0;
                        i {
                            margin-right: 12px;
                            &:before {
                                color: #515B65;
                            }
                        }
                    }
                }

            }
        }

        .fts-table-wrapper {
            position: relative;
            padding: 20px 0;
            border: 0;
            border-top: 1px solid #dbdfe2;
            margin-bottom: 0;
            &.no-padding {
                padding-top: 0;
            }

            .row {
                display: flex;
                justify-content: space-between;
                padding: 0 20px 20px;
                border-bottom: 1px solid #dbdfe2;
                .search-filter {
                    max-width: 345px;
                }
                .text-right {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    label {
                        margin: 0 16px 0 0;
                    }
                    select {
                        width: 80px;
                        background: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 8 4.2' style='enable-background:new 0 0 8 4.2;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%230088FF;%7D%0A%3C/style%3E%3Cpolygon class='st0' points='4,4.2 0,0 8,0 '/%3E%3C/svg%3E%0A") no-repeat right 0.75rem center/8px 10px #ffffff;
                    }
                }
            }
            .loader-sim-list  {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;

                background-color: rgba(255, 255, 255, 0.7);

                display: flex;
                justify-content: center;
                align-items: center;
                align-content: center;

                .sk-wave {
                    height: 60px;
                    .sk-rect {
                        width: 3px;
                        background-color: #39c354;
                        border-radius: 4px;
                    }
                }
                .text {
                    font-size: 15px;
                    margin: 30px 0 0 0;
                    font-weight: 700;
                }
            }
            .fts-table {
                position: relative;
                min-height: 240px;
                table {
                    margin-bottom: 20px;
                }
                .table-sim-tools {
                    a {
                        color: #0088ff;
                    }
                }
                .no-sims {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;

                    background-color: rgba(255, 255, 255, 0.7);

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;

                    .sk-wave {
                        height: 60px;
                        .sk-rect {
                            width: 3px;
                            background-color: #39c354;
                            border-radius: 4px;
                        }
                    }
                    .text {
                        font-size: 15px;
                        margin: 30px 0 0 0;
                        font-weight: 700;
                    }
                }
                .buttons-row {
                    display: flex;
                    justify-content: space-between;
                }
            }

            .nav-sim-query {
                display: flex;
                justify-content: space-between;
                padding: 0 20px;
                ul {
                    margin-bottom: 0;
                }
                &.no-buttons {
                    justify-content: center;
                }
            }

            .no-sims-uploaded {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;

                background-color: rgba(255, 255, 255, 0.7);

                display: flex;
                justify-content: center;
                align-items: center;
                align-content: center;

                h2 {
                    font-size: 15px;
                    margin: 0;
                    font-weight: 700;
                }
            }
            .buttons-table {
                display: flex;
                justify-content: space-between;
            }
        }
    }

    #fileFormatModal___BV_modal_header_ {
        padding-bottom: 0;
    }

    #jsonModal___BV_modal_body_ {
        position: relative;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        .fa-close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
        h3 {
            margin: 0 0 20px;
            font-size: 15px;
        }
        pre {
            flex-grow: 1;
            overflow: auto;
        }
        .close-bar {
            display: flex;
            justify-content: space-between;
        }
    }

    #fileFormatModal___BV_modal_body_ {
        padding-top: 0;
        .file-format-popup {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            padding: 0 20px 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;

            h3 {
                font-size: 15px;
                margin-top: 8px;
                margin-bottom: 20px;
            }

            .btn {
                width: 100px;
            }

            .btn-primary {
                margin: 0 10px 20px;
            }

            .btn-light {
                margin: 10px 0 0;
            }

            .csv {
                background-color: #00559F;
                border-color: #00559F;
            }
            .xls {
                background-color: #207245;
                border-color: #207245;
            }

            .close-icon {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
            }
        }
    }

    .dark-theme {
        .sim-tools {
            color: #ffffff;
            background-color: #3a4149;
            border-color: #1a1c1d;
            .bookmarks {
                border-color: #1a1c1d;
                .bookmark {
                    &.selected {
                        border-color: #1a1c1d;
                        border-bottom-color: #3a4149;
                    }
                }
            }
            .upload-sims-areas {
                .input-sims-area {
                    border-color: #1a1c1d;
                    .sims-input {
                        .add-sims-input {
                            background-color: #505a64;
                            border-color: #1a1c1d;
                            color: #fff;
                        }
                        .add-sims-btn {
                            border-color: #1a1c1d;
                        }
                    }
                }
                .dnd-area {
                    border-color: #1a1c1d;
                    .text {
                        h3 {
                            color: #fff;
                        }
                    }
                }
            }
            .invalid-sims-box {
                color: #fff;
                background-color: #6B3D3D;
                border-color: #FC4D4D;

                .invalid-sims-box-header {
                    i {
                        color: #fff;
                    }
                }

                .sims-group {
                    .desc {
                        color: #fff;
                    }
                }
                .list-of-sims {
                    .sim {
                        i {
                            &:before {
                                color: #fff;
                            }
                        }
                    }
                }
            }

            .fts-table-wrapper {
                border-color: #1a1c1d;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                .row {
                    border-color: #1a1c1d;
                    .search-filter {
                        .search-box {
                            .form-control {
                                background-color: #515b65;
                                border-color: #1a1c1d;
                                color: #fff;&::placeholder {
                                    color: #fff;
                                }
                            }
                        }
                    }
                    .text-right {
                        select {
                            background-color: #515b65;
                            border-color: #1a1c1d;
                            color: #fff;
                        }
                    }
                }

                .no-sims-uploaded {
                    background-color: rgba(0, 0, 0, 0.4);
                }
                .fts-table {
                    .no-sims {
                        background-color: rgba(0, 0, 0, 0.4);
                    }
                }

                .loader-sim-list  {
                    background-color: rgba(0, 0, 0, 0.4);
                }
            }
        }

        #jsonModal___BV_modal_body_ {
            pre {
                color: #fff;
            }
        }
    }
</style>
